import { render, staticRenderFns } from "./family-info.vue?vue&type=template&id=75cea417"
import script from "./family-info.vue?vue&type=script&lang=js"
export * from "./family-info.vue?vue&type=script&lang=js"
import style0 from "./family-info.vue?vue&type=style&index=0&id=75cea417&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports